/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at <http://mozilla.org/MPL/2.0/>. */

import classnames from "classnames";
import React from "react";

const AccessibleImage = props => {
  props = {
    ...props,
    className: classnames("img", props.className),
  };
  return <span {...props} />;
};

export default AccessibleImage;
